import React from 'react';
import PropTypes from 'prop-types';
import MdMenu from 'react-icons/lib/md/menu';
import MdClose from 'react-icons/lib/md/close';

import IconButton from '../../ui/IconButton';

const styleMenuIconButton = {
  alignSelf: 'center',
  position: 'absolute',
  left: 4,
  top: 4,
  height: 48,
  width: 48,
};

const MenuIconButton = props => (
  <IconButton
    className="MenuIconButton"
    color="white"
    label={props.isViewingMobileMenu ? (
      <MdClose size={24} />
    ):(
      <MdMenu size={24} />
    )}
    style={styleMenuIconButton}
    {...props}
  />
);

MenuIconButton.propTypes = {
  isViewingMobileMenu: PropTypes.bool,
};

MenuIconButton.defaultProps = {
  isViewingMobileMenu: false,
};

export default MenuIconButton;



// WEBPACK FOOTER //
// ./src/components/layout/Nav/MenuIconButton.js